import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import breakpoint from 'styled-components-breakpoint';

/**
 * Image
 *
 * This component is in charge of displaying
 * an image
 *
 * @param {string} className // className needed by styled components.
 * @param {string} src // src is the image source used to display this one.
 * @param {string} alt // alt is the image description used by screen readers.
 * @param {string} size // size is to define the image size (height, width).
 *
 * @return {jsx}
 */

const Image = ({ className, src, alt, size }) => (
  <img className={className} src={src} alt={alt} height={size} width={size} />
);

/**
 * PropTypes Validation
 */
const { string } = PropTypes;
Image.propTypes = {
  className: string,
  src: string,
  alt: string,
  size: string,
};

/**
 * Default Props
 */
Image.defaultProps = {
  className: '',
  src: '',
  alt: '',
  size: '180px',
};

export default styled(Image)`
  margin: 2.6rem 0 3rem 0;
  ${breakpoint('xs', 'md')`
    margin: 1.6rem 0 2rem 0;
`};
`;



// WEBPACK FOOTER //
// ./src/components/Image/index.js